import React from "react";
import { Button } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useNavigate } from "react-router-dom";

interface ButtonUXInterface {
  text: string;
  hasBorder?: boolean;
  lowercase?: boolean;
  width?: string;
  hasIcon?: boolean;
  isModal?: boolean;
  page?: number;
  isFooter?: boolean;
  isMain?: boolean;
  parallax?: any;
  fontStyle?: string;
  padding?: string;
}
const ButtonUX = ({
  text,
  isFooter,
  hasBorder,
  lowercase,
  width,
  padding,
  hasIcon,
  isModal,
  fontStyle,
  page = 0, // Add a default value of 0 to the page parameter
  parallax,
}: ButtonUXInterface) => {
  const navigate = useNavigate();
  const handleClick = () => {
    const encodedText = encodeURIComponent(text).toUpperCase();
    if (text === "Home") {
      navigate("/");
    } else if (text === "Contact") {
      setTimeout(() => {
        const footer = document.getElementById("footer");
        if (footer) {
          footer.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    } else {
      const element = document.getElementById(encodedText);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate(`/${text}`);
      }
    }
  };
  return (
    <Button
      sx={{
        width: width || undefined,
        backgroundColor: "transparent",
        borderRadius: "50px",
        padding: hasIcon ? "5px 30px" : padding || "5px 25px",
        color: "#fff", // Colore del testo bianco
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
        fontSize: isModal ? "10vw" : "13px",
        textAlign: isFooter ? "left" : "center",
        fontFamily: isModal || isFooter ? "ivymode" : "degular",
        fontStyle: fontStyle || "normal",
        fontWeight: 500,
        lineHeight: "14px" /* 116.667% */,
        letterSpacing: isFooter ? "2px" : "1px",
        textTransform: lowercase === true || isFooter ? "none" : "uppercase",
        border: hasBorder ? "1px solid white" : "none",
      }}
      variant="text"
      onClick={handleClick}
      endIcon={hasIcon ? <CalendarMonthIcon /> : null}
    >
      {text}
    </Button>
  );
};

export default ButtonUX;
